
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        description: {
            type: String,
            default: null,
        },
        carInfo: {
            type: Object,
            default: null,
        },
        height: {
            type: Number,
            default: null,
        },
        width: {
            type: Number,
            default: null,
        },
        places: {
            type: Number,
            default: null,
        },
        transportTypeName: {
            type: String,
            default: null,
        },
        insurance: {
            type: String,
            default: null,
        },
        dopOrderNumber: {
            type: String,
            default: null,
        },
        length: {
            type: Number,
            default: null,
        },
        weight: {
            type: Number,
            default: null,
        },
        isStacked: {
            type: Number,
            default: null,
        },
        declaredPrice: {
            type: Number,
            default: null,
        },
        specialConditions: {
            type: String,
            default: null,
        },
        cargoName: {
            type: String,
            default: null,
        },
        isDangerous: {
            type: Number,
            default: null,
        },
        ftlType: {
            type: Number,
            default: null,
        },
        hsCode: {
            type: String,
            default: null,
        },
        customsClearance: {
            type: Number,
            default: null,
        },
        packaging: {
            type: String,
            default: null,
        },
    },
})
